/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: Reflect
 * root Object
 * @constructor
 */
window.Reflect = function() {};
$hxClasses['Reflect'] = Reflect;
/** @private @type {Array} */
Reflect.__name__ = ["Reflect"];

/**
 * hasField
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => field, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {null}  o 
 * @param {string}  field 
 * @return {boolean}
 */
Reflect.hasField = function(o,field) {
	return Object.prototype.hasOwnProperty.call(o,field);
};


/**
 * field
 *
 * @public
 * @static
 * @param {Array}  o 
 * @param {string}  field 
 * @return {Object}
 */
Reflect.field = function(o,field) {
	/** @type {Object} */ 
	var v = null;
	try {
		v = o[field];
	} catch( e ) {
	}
	return v;
};


/**
 * setField
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => field, t => TInst(String,[]), opt => false },{ name => value, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * @public
 * @static
 * @param {null}  o 
 * @param {string}  field 
 * @param {null}  value 
 * @return {void}
 */
Reflect.setField = function(o,field,value) {
	o[field] = value;
};


/**
 * getProperty
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => field, t => TInst(String,[]), opt => false }],TDynamic(null))
 * @public
 * @static
 * @param {null}  o 
 * @param {string}  field 
 * @return {null}
 */
Reflect.getProperty = function(o,field) {
	/** @type {boolean} */ 
	var tmp;
	return o == null?null:o.__properties__ && (tmp = o.__properties__["get_" + field])?o[tmp]():o[field];
};


/**
 * setProperty
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => field, t => TInst(String,[]), opt => false },{ name => value, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * @public
 * @static
 * @param {null}  o 
 * @param {string}  field 
 * @param {null}  value 
 * @return {void}
 */
Reflect.setProperty = function(o,field,value) {
	var /** @type {boolean} */ tmp;
	if(o.__properties__ && (tmp = o.__properties__["set_" + field])) o[tmp](value); else o[field] = value;
};


/**
 * callMethod
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => func, t => TDynamic(null), opt => false },{ name => args, t => TInst(Array,[TDynamic(null)]), opt => false }],TDynamic(null))
 * @public
 * @static
 * @param {null}  o 
 * @param {null}  func 
 * @param {Array}  args 
 * @return {null}
 */
Reflect.callMethod = function(o,func,args) {
	return func.apply(o,args);
};


/**
 * fields
 *
 * Returns array of only own properties of object. Ignores the properties from prototype.
 *
 * @public
 * @static
 * @param {object} o
 * @return {Array}
 */
Reflect.fields = function(o) {
	/** @type {Array} */
	var a = [];
	if (o != null) {
		for (var f in o) {
			if (o.hasOwnProperty(f)) {
				a.push(f);
			}
		}
	}
	return a;
};


/**
 * isFunction
 *
 * $type TFun([{ name => f, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {null}  f 
 * @return {boolean}
 */
Reflect.isFunction = function(f) {
	return typeof(f) == "function" && !(f.__name__ || f.__ename__);
};


/**
 * compare
 *
 * $type TFun([{ name => a, t => TInst(compare.T,[]), opt => false },{ name => b, t => TInst(compare.T,[]), opt => false }],TInst(Int,[]))
 * @public
 * @static
 * @param {compare.T}  a 
 * @param {compare.T}  b 
 * @return {number}
 */
Reflect.compare = function(a,b) {
	return a == b?0:a > b?1:-1;
};


/**
 * compareMethods
 *
 * $type TFun([{ name => f1, t => TDynamic(null), opt => false },{ name => f2, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {null}  f1 
 * @param {null}  f2 
 * @return {boolean}
 */
Reflect.compareMethods = function(f1,f2) {
	if(f1 == f2) return true;
	if(!Reflect.isFunction(f1) || !Reflect.isFunction(f2)) return false;
	return f1.scope == f2.scope && f1.method == f2.method && f1.method != null;
};


/**
 * isObject
 *
 * $type TFun([{ name => v, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {null}  v 
 * @return {boolean}
 */
Reflect.isObject = function(v) {
	if(v == null) return false;
	/** @type {string} */ 
	var t = typeof(v);
	return t == "string" || t == "object" && !v.__enum__ || t == "function" && (v.__name__ || v.__ename__);
};


/**
 * deleteField
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => f, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {null}  o 
 * @param {string}  f 
 * @return {boolean}
 */
Reflect.deleteField = function(o,f) {
	if(!Reflect.hasField(o,f)) return false;
	delete(o[f]);
	return true;
};


/**
 * copy
 *
 * $type TFun([{ name => o, t => TInst(copy.T,[]), opt => false }],TInst(copy.T,[]))
 * @public
 * @static
 * @param {copy.T}  o 
 * @return {copy.T}
 */
Reflect.copy = function(o) {
	var /** @type {*} */ o2 = { };
	var /** @type {number} */ _g = 0, /** @type {Array} */ _g1 = Reflect.fields(o);
	while(_g < _g1.length) {
		var /** @type {string} */ f = _g1[_g];
		++_g;
		o2[f] = Reflect.field(o,f);
	}
	return o2;
};


/**
 * makeVarArgs
 *
 * @public
 * @static
 * @param {Function}  f 
 * @return {Function}
 */
Reflect.makeVarArgs = function (f) {
	return function () {
		/** @type {Array} */
		var a = Array.prototype.slice.call(arguments);
		return f(a);
	};
};

/** @type {Reflect} */
Reflect.prototype.__class__ = Reflect;
